import { useSelector, useDispatch } from 'react-redux';
import { useCallback, useEffect } from 'react';
import {
  resetSelectedProduct,
  setSelectedProduct,
} from '../data/pendingGuarantees/actions';
import { selectPendingGuaranteesProductFamily } from '../data/pendingGuarantees/selectors';
import { productFamilyThemeClass } from '../constants/productFamily';

export const usePendingGuaranteesProductFamily = () => {
  const selectedProduct = useSelector(selectPendingGuaranteesProductFamily);
  const dispatch = useDispatch();
  const setProduct = useCallback(
    productId => {
      dispatch(setSelectedProduct(productId));
    },
    [dispatch]
  );
  return [selectedProduct, setProduct];
};

export const useResetPendingGuaranteesProductFamilyOnExit = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetSelectedProduct());
    };
  }, [dispatch]);
};

export const usePendingGuaranteesProductFamilyTheme = () => {
  const selectedProduct = useSelector(selectPendingGuaranteesProductFamily);
  return productFamilyThemeClass(selectedProduct);
};
